import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { dark } from '@clerk/themes';
import { ClerkProvider } from '@clerk/clerk-react';

// Set your publishable key in .env file - we'll use a placeholder for now
// In production, get this from environment variables
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || 'pk_test_your-publishable-key';

console.log('Clerk Publishable Key:', CLERK_PUBLISHABLE_KEY ? `${CLERK_PUBLISHABLE_KEY.substring(0, 10)}...` : 'undefined');

if (!CLERK_PUBLISHABLE_KEY || CLERK_PUBLISHABLE_KEY === 'pk_test_your-publishable-key') {
  console.warn('Missing or default Clerk Publishable Key - this will not work in production.');
}

// Check if we're in production
const isProduction = process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'production';

console.log('Environment:', process.env.NODE_ENV, process.env.REACT_APP_ENV);
console.log('Running in production mode:', isProduction);

// Configure Clerk with navigation and routing settings
const clerkOptions = {
  navigate: (to) => window.location.href = to,
  routing: "path",
  path: "/",
  signInUrl: "/sign-in",
  signUpUrl: "/sign-up",
  afterSignInUrl: "/login-success",
  afterSignUpUrl: "/login-success",
  
  // Fix CORS issues by configuring credentials mode
  loadClerk: true,
  isSatellite: false,
  standardBrowser: true,
  noCredentials: true
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider 
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: '#4285F4',
          colorBackground: '#000000',
          colorInputBackground: '#1a1a1a',
          colorText: '#ffffff',
          colorTextSecondary: '#b3b3b3',
        },
      }}
      publishableKey={CLERK_PUBLISHABLE_KEY} 
      {...clerkOptions}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);